import { request } from "./base";

export const getCurrencyList = async (oems: string[] = []) => request("/currency/by-oem", {
    method: "POST",
    body: JSON.stringify({ oems: oems }),
  }).then((res) => res.json()).then(({ data }) => data);
